window.$ = window.jQuery = require('jquery');
window.moment = require('moment');

require('./bootstrap');
